import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '需求单',
    type: 'CAT_REQ',
}
